export default {"src":"/_next/static/media/bow.6eae1291.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};